import React from 'react';
import { styled } from 'baseui';
import { ListItem } from 'baseui/list';
import type { Theme } from 'baseui/theme';
import type { HeaderInfoT } from '../annotations/types';
import { HeaderContent } from './header-content';
import type { ContentRendererT } from './types';
type Props = {
  label: string;
  headerInfo: HeaderInfoT;
  icon: React.ReactNode;
  showHideButton?: ContentRendererT;
  deleteButton?: ContentRendererT;
};
const ActionButtonsRow = styled('div', {
  display: 'flex',
  alignItems: 'center'
});
const listItemOverrides = {
  Root: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      padding: `${$theme.sizing.scale300} ${$theme.sizing.scale500}`,
      backgroundColor: $theme.colors.backgroundSecondary,
      width: 'auto',
      borderRadius: $theme.borders.radius400,
      overflow: 'hidden'
    })
  },
  Content: {
    style: {
      margin: '0',
      minHeight: 'auto',
      padding: '0'
    }
  }
};
export const AnnotationHeader = ({
  label,
  headerInfo,
  icon,
  showHideButton,
  deleteButton
}: Props) => {
  return <ListItem hasDivider={false} overrides={listItemOverrides} aria-label={`${label} annotation header`}>
      <HeaderContent label={label} headerInfo={headerInfo} icon={icon} />
      <ActionButtonsRow>
        {showHideButton && showHideButton(label, headerInfo)}
        {deleteButton && deleteButton(label, headerInfo)}
      </ActionButtonsRow>
    </ListItem>;
};